// Initial Setup
const canvas = document.querySelector('canvas')
const c = canvas.getContext('2d')

canvas.width = innerWidth
canvas.height = innerHeight-5

// Variables
const mouse = {
    x: innerWidth / 2,
    y: innerHeight / 2
}

const colors = ['#2185C5', '#7ECEFD', '#FFF6E5', '#FF7F66']

var gravity = .2
var friction = 0.8

// Event Listeners
addEventListener('mousemove', event => {
    mouse.x = event.clientX
    mouse.y = event.clientY
})

addEventListener('resize', () => {
    canvas.width = innerWidth
    canvas.height = innerHeight

    init()
})

addEventListener('click',function() {
    init()
})

// Utility Functions
function randomIntFromRange(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min)
}

function randomColor(colors) {
    return colors[Math.floor(Math.random() * colors.length)]
}

function distance(x1, y1, x2, y2) {
    const xDist = x2 - x1
    const yDist = y2 - y1

    return Math.sqrt(Math.pow(xDist, 2) + Math.pow(yDist, 2))
}

// Objects
function Ball(x, y, dx, dy, radius, color) {
    this.x = x
    this.y = y
    this.dx = dx
    this.dy = dy
    this.radius = radius
    this.color = color
}

Ball.prototype.update = function() {
    if(this.y + this.radius +this.dy >= canvas.height) {
        this.dy = -this.dy * friction
    } else {
        this.dy+=gravity
    }
    if(this.x + this.radius >= canvas.width || this.x - this.radius <= 0) {
        this.dx = -this.dx
    }
    this.x+=this.dx
    this.y+=this.dy 
    this.draw()
}

Ball.prototype.draw = function() {
    c.beginPath()
    c.arc(this.x, this.y, this.radius, 0, Math.PI * 2, false)
    c.fillStyle = this.color
    c.strokeStyle = "black"
    c.fill()
    c.stroke()
    c.closePath()
}

// Implementation
var ball;
let ballArray
function init() {
    ballArray = []
    for (var i = 0; i < 75; i++) {
        var rad = randomIntFromRange(25,45)
        var x = randomIntFromRange(rad,canvas.width-rad)
        var y = randomIntFromRange(rad,canvas.height-rad)
        var dx = randomIntFromRange(-5,5)
        var color = randomColor(colors)
        ballArray.push(new Ball(x,y,dx,gravity,rad,color))
    }
}

// Animation Loop
function animate() {
    requestAnimationFrame(animate)
    c.clearRect(0, 0, canvas.width, canvas.height)
    //ball.update();
    //c.fillText('HTML CANVAS BOILERPLATE', mouse.x, mouse.y)
    for(var i = 0; i < ballArray.length; i++) {
        ballArray[i].update()
    }
}

init()
animate()



// WEBPACK FOOTER //
// ./src/canvas.js